import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { Helmet } from 'react-helmet';
import AddSubscription from './add_subscriptions'
import DeleteConfirmation from './modals/confirmation';
import { useAuth } from '../../providers/auth_provider';
import SubscriptionStatusDropdown from './modals/active_inactive_modal';
import EditSubscription from './edit_subscription';


export default function Subscriptions() {
    const { token } = useAuth();
    const [subscriptions, setSubscriptions] = useState([]);
    const [subscriptionId, setSubscriptionId] = useState();
    const [searchName, setSearchName] = useState('');
    useEffect(() => {
        if (token) {
            fetchSubscriptions();
        }
    }, [token, searchName]);


    const fetchSubscriptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/plan/all?search=${searchName ? searchName : ''}`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            });
            setSubscriptions(response.data.plans)
        } catch (error) {
            console.error('Error fetching subscriptions:', error)
        }
    }

    return (
        <>
            <Helmet>
                <title>Manage Subscriptions - Enervybe</title>
            </Helmet>
            {/* Subscriptions List Table */}
            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">

                        <h5 className="card-title">Subscriptions List</h5>
                        <button
                            className="btn btn-sm btn-label-primary waves-effect waves-light"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasAddSubscription">
                            <i className='ri-add-line d-none d-sm-inline-block me-2'></i>
                            <i className="ri-add-line me-0 me-sm-1 d-inline-block d-sm-none" />
                            <span className="d-none d-sm-inline-block">Add New Subscription</span>
                        </button>
                    </div>
                </div>
                <div className="card-datatable text-nowrap">
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div className="d-flex justify-content-between px-5">
                            <div className="dataTables_length" id="DataTables_Table_0_length">
                                <input
                                    type="search"
                                    className="form-control form-control-sm"
                                    placeholder="Search Subscription"
                                    aria-controls="DataTables_Table_0"
                                    value={searchName}
                                    onChange={(e) => setSearchName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="datatables-ajax table table-bordered dataTable no-footer"
                                id="DataTables_Table_0"
                                aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Price</th>
                                        <th>Currency</th>
                                        {/* <th>Duration</th> */}
                                        <th>Discount</th>
                                        <th>Qty</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {subscriptions?.map((subscription, index) => (
                                        <tr className="odd" key={subscription.id}>
                                            <td>{index + 1}</td>
                                            <td>{subscription.name}</td>
                                            <td style={{ whiteSpace: "pre-line" }}>{subscription.description}</td>
                                            <td>{subscription.price}</td>
                                            <td>{subscription.currency}</td>
                                            {/* <td className='text-capitalize'>{subscription.duration + " " + subscription.duration_unit}</td> */}
                                            <td>{subscription.discount}%</td>
                                            <td>{subscription.price_of_quantity}</td>
                                            <td className='text-capitalize'>
                                                <SubscriptionStatusDropdown subscription={subscription} fetchSubscriptions={fetchSubscriptions} />
                                            </td>
                                            <td>
                                                <div className='gap-2 d-flex'>
                                                    <button onClick={() => setSubscriptionId(subscription.id)} className="btn text-primary" data-bs-toggle="offcanvas" data-bs-target="#offcanvasEditSubscription">
                                                        <span className="d-none d-sm-inline-block">
                                                            Edit
                                                        </span>
                                                    </button>
                                                    <DeleteConfirmation subscription={subscription} fetchSubscriptions={fetchSubscriptions} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Offcanvas to add new subscription */}
                <EditSubscription subscriptionId={subscriptionId} fetchSubscriptions={fetchSubscriptions} />
                <AddSubscription fetchSubscriptions={fetchSubscriptions} />
            </div>
        </>

    )
}
